import Vue from 'vue'
import i18next from 'i18next'
import XHR from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import VueI18Next from '@panter/vue-i18next'
import store from '../store/'
import BackendAdapter from 'i18next-multiload-backend-adapter'

Vue.use(VueI18Next)

i18next.use(LanguageDetector).use(BackendAdapter).init({
  fallbackLng: 'en',
  whitelist: ['en', 'fi'],
  allowMultiloading: true,
  defaultNS: 'common',
  ns: ['default',
    'common',
    'nav',
    'view-landing',
    'sign-in',
    'sign-up',
    'account',
    'journey',
    'work-engagement-snapshot',
    'validate-email',
    'satisfaction-snapshot',
    'journal',
    'profile',
    'personal',
    'personal-results',
    'team-results',
    'challenges',
    'tos',
    'pp'],
  backend: {
    backend: XHR,
    backendOption: {
      loadPath: process.env.VUE_APP_API_URL + '/translations/multiload.json?lng={{lng}}&ns={{ns}}'
    }
  }
}, () => {
  setTimeout(() => {
    store.dispatch('setTranslationsLoading', false)
  }, 500)
})

i18next.on('languageChanged', function (lang) {
  const html = document.documentElement
  html.setAttribute('lang', lang)
  setTimeout(() => {
    store.dispatch('setTranslationsLoading', false)
  }, 300)
})

const i18n = new VueI18Next(i18next)

export default i18n
